import { createContext } from "react";

const IsNextYearEarlyRegistrationContext = createContext<boolean>(false);

export default IsNextYearEarlyRegistrationContext;